import React, { Component } from 'react'
import Axios from 'axios';
import {Link} from 'react-router-dom';
import '../../css/style.css';

import $ from 'jquery';
import Constant from '../Constant';
import { getAccessToken } from '../../hooks/AccessToken';

class Upload extends Component {

/*..................................... default state object ............................................*/
    
    state = {
        image: null,
        title: '',
        ERROR: true
    } 

    handleChange = (e) => {
        this.setState({ 
            [e.target.id]: e.target.value
        });
    }

    handleImageChange = (e) => {
        this.setState({
            [e.target.id]: e.target.files[0]
        })
    };
  

/*.................. Integrate API for update banner...............................................*/

    handleSubmit = async event => {
        try{
            event.preventDefault();
            let token = getAccessToken();
            const form_data = new FormData();
            
            let title = this.state.title;
            if(title === '') {
                $("#title-error-msg").text('title is required');
        
                return false;
            }
            if(this.state.image === null) {
                $("#thumbnail-error-msg").text('Thumbnail is required');
                return false;
            }

            let fileName = this.state.image.name;
            let extension = fileName.split('.').pop();

            if(extension !== 'jpg' && extension !== 'png') {
                $("#thumbnail-error-msg").text('Only jpg and png file type are allow !');
                return false;
            }

            form_data.append('contentThumbnail', this.state.image, this.state.image.name); 
            form_data.append('title', title);  
            Axios.post(Constant.apiBasePath + 'content-thumbnail/upload', form_data, { headers: { 'token': token }}).then(response => {
            const getResults = response.data.message;
            
                if(response.data.status === Constant.statusSuccess) {
                    $('#gen-message').text(getResults);
                    $('#gen-message').css('color', 'green');
                    setTimeout(function() { window.location.reload(); }, 3000 );
                }

                else {
                    $('#gen-message').text(getResults);
                    $('#gen-message').css('color', 'red');
                    return false;
                }

            });
        }
        catch(err) {
            console.log(err);
        }       
    }


/*.................................end API .................................................................*/

    render() {
       
        return (
                <div className="content-page contest-add-update-page event-consistent-page multimedia-add-page thumbnail-upload-page">
                    <div className="content page-content-spaced">
                        <div className="event-management-header">
                            <div className="header-content">
                                <div className="header-title">
                                    <h4 className="page-title-heading">Upload Thumbnail</h4>
                                    <p className="header-subtitle">Add a new thumbnail asset for content modules.</p>
                                </div>
                                <div className="header-actions">
                                    <Link to="/thumbnail-management" className="btn openmic-link-btn">Back to Thumbnail Management</Link>
                                </div>
                            </div>
                        </div>

                        <div className="event-management-body">
                            <div className="row">
                                <div className="col-12 contest-form-column">
                                    <div className="card contest-form-card">
                                        <div className="card-body contest-form-card-body"> 
                                            <form onSubmit={this.handleSubmit}>
                                                <p id="gen-message" className="message-feedback"></p>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor='updateImage' className='update'>Title *</label>
                                                            <input type="text" id="title" className="form-control" onChange={ this.handleChange } defaultValue={ this.state.title } />
                                                            <p id="title-error-msg" className='text-danger'></p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className="col-md-6">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="updateImage" className="update">Thumbnail *</label>
                                                            <input type="file" id="image" name="image" accept="image/png, image/jpg" className="form-control" onChange={this.handleImageChange}/>
                                                            <p id="thumbnail-error-msg" className='text-danger'></p>
                                                        </div> 
                                                    </div> 
                                                </div>

                                                <div className="d-flex flex-wrap align-items-center" style={{ gap: '10px' }}>
                                                    <button type="submit" className="btn btn-info">Upload</button>
                                                    <Link to="/thumbnail-management" className="btn openmic-link-btn">Cancel</Link>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        )
    }
}
export default Upload;


